
/* CUSTOM BUNDLE BUILDER — SEPARATE JAVASCRIPT */

(() => {
  // Prevent duplicate global event listeners when the
  // same asset is loaded by multiple section instances.
  if (window.__customBundleBuilderLoaded) return;
  window.__customBundleBuilderLoaded = true;

  function initBundleBuilder(root) {
    if (!root || root.dataset.initialized === "true") return;

    root.dataset.initialized = "true";

    const currencyCode = root.dataset.currency || "USD";
    const locale = root.dataset.locale || "en";
    const availableSlots = Number(root.dataset.maxSlots || 0);

    // DISCOUNT TOGGLE
    const discountEnabled =
      root.dataset.discountEnabled === "true";

    const discountPercent = discountEnabled
      ? Math.max(0, Math.min(50, Number(root.dataset.discountPercent || 0)))
      : 0;

    const discountCode = discountEnabled
      ? (root.dataset.discountCode || "").trim()
      : "";

    const selections = {};
    let bundleSize = 2;
    let activeSlot = null;

    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) =>
      Array.from(root.querySelectorAll(selector));

    /* CURRENCY */

    function formatMoney(cents) {
      const amount = Number(cents) / 100;

      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency: currencyCode
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2) + " " + currencyCode;
      }
    }

    /* CALCULATIONS */

    function calculateTotals(chosen) {
      const original = chosen.reduce(
        (sum, item) => sum + item.price,
        0
      );

      const savings = discountEnabled
        ? Math.round(original * discountPercent / 100)
        : 0;

      return {
        original,
        savings,
        discounted: original - savings
      };
    }

    function getChosenProducts() {
      return Array.from(
        { length: bundleSize },
        (_, index) => selections[index + 1]
      );
    }

    /* STEP NAVIGATION */

    function showStep(step) {
      $$("[data-step]").forEach((panel) => {
        panel.hidden = Number(panel.dataset.step) !== step;
      });

      $$("[data-progress]").forEach((indicator) => {
        indicator.classList.toggle(
          "is-current",
          Number(indicator.dataset.progress) === step
        );
      });

      const picker = $("[data-picker]");
      if (picker) picker.hidden = true;

      if (step === 3) refreshSelections();
      if (step === 4) renderReview();

      if (step !== 1) {
        root.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }

    /* REFRESH PRODUCT SELECTIONS */

    function refreshSelections() {
      $$("[data-slot-open]").forEach((button) => {
        const slot = Number(button.dataset.slotOpen);
        const wrapper = button.closest("[data-slot-wrap]");

        wrapper.hidden = slot > bundleSize;

        const selected = selections[slot];

        button.classList.toggle("is-picked", !!selected);

        const clearButton = $(
          '[data-clear-slot="' + slot + '"]'
        );

        if (clearButton) {
          clearButton.hidden = !selected || slot > bundleSize;
        }

        const label = button.querySelector("[data-slot-label]");

        label.textContent = selected
          ? selected.title + " — " +
            formatMoney(selected.price) + " ✓"
          : "Select a product +";

        const imageWrapper = button.querySelector(".bb-slot-image");

        if (imageWrapper) {
          if (selected && selected.image) {
            if (!imageWrapper.dataset.originalMarkup) {
              imageWrapper.dataset.originalMarkup =
                imageWrapper.innerHTML;
            }

            imageWrapper.replaceChildren();

            const image = document.createElement("img");
            image.src = selected.image;
            image.alt = selected.title;
            image.loading = "lazy";

            imageWrapper.appendChild(image);
          } else if (imageWrapper.dataset.originalMarkup) {
            imageWrapper.innerHTML =
              imageWrapper.dataset.originalMarkup;
          }
        }
      });

      const chosen = getChosenProducts().filter(Boolean);

      const clearAll = $("[data-clear-all]");
      if (clearAll) clearAll.hidden = chosen.length === 0;

      $("[data-selected-count]").textContent = chosen.length;
      $("[data-bundle-size]").textContent = bundleSize;

      const totals = calculateTotals(chosen);

      const showSavings =
        discountEnabled &&
        discountPercent > 0 &&
        chosen.length > 0;

      // Original total and savings are hidden when
      // the bundle discount toggle is OFF.
      const originalTotal = $("[data-original-total]");
      originalTotal.textContent = formatMoney(totals.original);
      originalTotal.hidden = !showSavings;

      $("[data-total]").textContent =
        formatMoney(totals.discounted);

      const savingsText = $("[data-savings-text]");
      savingsText.hidden = !showSavings;

      savingsText.textContent = showSavings
        ? "Save " + formatMoney(totals.savings) +
          " (" + discountPercent + "%) • estimated"
        : "";

      $("[data-review-button]").disabled =
        chosen.length !== bundleSize;
    }

    /* REVIEW BUNDLE */

    function renderReview() {
      const grid = $("[data-review-grid]");
      grid.replaceChildren();

      const chosen = getChosenProducts();

      if (chosen.some((item) => !item)) {
        showStep(3);
        return;
      }

      chosen.forEach((item, index) => {
        const card = document.createElement("div");
        card.className = "bb-review-item";

        if (item.image) {
          const image = document.createElement("img");
          image.src = item.image;
          image.alt = item.title;
          image.loading = "lazy";
          card.appendChild(image);
        }

        const boxLabel = document.createElement("span");
        boxLabel.textContent = "BOX " + (index + 1);
        card.appendChild(boxLabel);

        const title = document.createElement("strong");
        title.textContent = item.title;
        card.appendChild(title);

        const price = document.createElement("span");
        price.textContent = formatMoney(item.price);
        card.appendChild(price);

        grid.appendChild(card);
      });

      const totals = calculateTotals(chosen);

      const showSavings =
        discountEnabled && discountPercent > 0;

      // Hide all discount-related rows and notes
      // when discount is disabled.
      const originalRow = $("[data-review-original-row]");
      const discountRow = $("[data-review-discount-row]");
      const discountNote = $("[data-discount-note]");

      if (originalRow) originalRow.hidden = !showSavings;
      if (discountRow) discountRow.hidden = !showSavings;
      if (discountNote) discountNote.hidden = !showSavings;

      $("[data-review-original]").textContent =
        formatMoney(totals.original);

      $("[data-review-savings]").textContent =
        "−" + formatMoney(totals.savings);

      $("[data-discount-percent]").textContent =
        discountPercent;

      $("[data-review-total]").textContent =
        formatMoney(totals.discounted);

      const finalLabel = $("[data-final-label]");
      if (finalLabel) {
        finalLabel.textContent = showSavings
          ? "Estimated bundle total"
          : "Bundle total";
      }
    }

    /* START AND BACK */

    $$("[data-go]").forEach((button) => {
      button.addEventListener("click", () => {
        const step = Number(button.dataset.go);

        if (
          step === 4 &&
          getChosenProducts().some((item) => !item)
        ) {
          showStep(3);
          return;
        }

        showStep(step);
      });
    });

    /* SELECT BUNDLE SIZE */

    $$("[data-size]").forEach((button) => {
      button.addEventListener("click", () => {
        const selectedSize = Number(button.dataset.size);

        if (selectedSize > availableSlots) return;

        bundleSize = selectedSize;

        $$("[data-size]").forEach((sizeButton) => {
          sizeButton.setAttribute(
            "aria-pressed",
            String(sizeButton === button)
          );
        });

        showStep(3);
      });
    });

    /* OPEN PRODUCT PICKER */

    $$("[data-slot-open]").forEach((button) => {
      button.addEventListener("click", () => {
        activeSlot = Number(button.dataset.slotOpen);

        const picker = $("[data-picker]");
        picker.hidden = false;

        $$("[data-products-for]").forEach((grid) => {
          grid.hidden =
            Number(grid.dataset.productsFor) !== activeSlot;
        });

        $("[data-picker-title]").textContent =
          button.querySelector(".bb-slot-label").textContent;

        picker.scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        });
      });
    });

    /* CLOSE PICKER */

    $("[data-picker-close]").addEventListener("click", () => {
      $("[data-picker]").hidden = true;
    });

    /* CLEAR ONE PRODUCT */

    $$("[data-clear-slot]").forEach((button) => {
      button.addEventListener("click", () => {
        const slot = Number(button.dataset.clearSlot);

        delete selections[slot];

        $("[data-picker]").hidden = true;
        refreshSelections();
      });
    });

    /* CLEAR ALL PRODUCTS */

    $("[data-clear-all]").addEventListener("click", () => {
      Object.keys(selections).forEach((slot) => {
        delete selections[slot];
      });

      $("[data-picker]").hidden = true;
      refreshSelections();
    });

    /* VARIANT PRICE UPDATES */

    $$("[data-variant-select]").forEach((select) => {
      select.addEventListener("change", () => {
        const card = select.closest("[data-product-card]");

        const option = select.tagName === "SELECT"
          ? select.selectedOptions[0]
          : select;

        if (!option) return;

        card.querySelector(".bb-money").textContent =
          formatMoney(Number(option.dataset.price));
      });
    });

    /* CHOOSE PRODUCT */

    $$("[data-choose-product]").forEach((button) => {
      button.addEventListener("click", () => {
        if (!activeSlot) return;

        const card = button.closest("[data-product-card]");
        const select = card.querySelector("[data-variant-select]");

        const option = select.tagName === "SELECT"
          ? select.selectedOptions[0]
          : select;

        if (!option || option.dataset.available !== "true") {
          return;
        }

        const image = card.querySelector(".bb-product-image img");

        selections[activeSlot] = {
          variantId: Number(select.value),
          price: Number(option.dataset.price),
          title:
            button.dataset.productTitle +
            (
              select.tagName === "SELECT"
                ? " — " + option.textContent.trim()
                : ""
            ),
          image: image ? image.src : ""
        };

        $("[data-picker]").hidden = true;
        $("[data-error]").hidden = true;

        refreshSelections();
      });
    });

    /* ADD BUNDLE TO CART */

    $("[data-add-bundle]").addEventListener(
      "click",
      async (event) => {
        const button = event.currentTarget;
        const error = $("[data-review-error]");
        error.hidden = true;

        const chosen = getChosenProducts();

        if (chosen.some((item) => !item)) {
          showStep(3);
          return;
        }

        button.disabled = true;

        const originalText = button.textContent;
        button.textContent = "Adding…";

        // Group identical variant IDs.
        const grouped = new Map();

        chosen.forEach((item) => {
          grouped.set(
            item.variantId,
            (grouped.get(item.variantId) || 0) + 1
          );
        });

        const items = Array.from(
          grouped,
          ([id, quantity]) => ({ id, quantity })
        );

        const base = window.Shopify?.routes?.root || "/";

        try {
          const response = await fetch(
            base + "cart/add.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
              },
              body: JSON.stringify({ items })
            }
          );

          const data = await response.json();

          if (!response.ok) {
            throw new Error(
              data.description ||
              data.message ||
              "Could not add this bundle."
            );
          }

          /*
           * DISCOUNT ON:
           * Redirect through the Shopify discount permalink.
           *
           * DISCOUNT OFF:
           * Go directly to the cart without submitting a code.
           */
          if (
            discountEnabled &&
            discountPercent > 0 &&
            discountCode
          ) {
            window.location.href =
              base +
              "discount/" +
              encodeURIComponent(discountCode) +
              "?redirect=" +
              encodeURIComponent(base + "cart");
          } else {
            window.location.href = base + "cart";
          }

        } catch (err) {
          error.textContent =
            err.message ||
            "Something went wrong. Please try again.";

          error.hidden = false;
          button.disabled = false;
          button.textContent = originalText;
        }
      }
    );

    /* CHECK SECTION CONFIGURATION */

    if (availableSlots < 2) {
      const startButton = $('[data-go="2"]');

      if (startButton) startButton.disabled = true;

      console.warn(
        "Bundle Builder: Add at least two Bundle slot blocks."
      );
    }

    showStep(1);
  }

  /* INITIALIZE ALL BUNDLE BUILDERS */

  function initAllBundleBuilders(container = document) {
    if (container.matches?.("[data-bb-root]")) {
      initBundleBuilder(container);
    }

    container
      .querySelectorAll("[data-bb-root]")
      .forEach(initBundleBuilder);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initAllBundleBuilders(),
      { once: true }
    );
  } else {
    initAllBundleBuilders();
  }

  /* SHOPIFY THEME EDITOR */

  document.addEventListener(
    "shopify:section:load",
    (event) => initAllBundleBuilders(event.target)
  );
})();
